import { Mandant } from '../../util/types';
import bannerUWH from './uwh/banner.jpeg';
import bannerTUDO from './tudo/banner.png';
import bannerRUB from './rub/banner.svg';
import bannerHHU from './hhu/banner.png';
import bannerRIL from './ril/banner.jpg';

export const getBanner = (mandant: Mandant): string => {
  switch (mandant) {
    case 'tudo':
      return bannerTUDO;
    case 'uwh':
      return bannerUWH;
    case 'hhu':
      return bannerHHU;
    case 'rub':
      return bannerRUB;
    case 'ril':
      return bannerRIL;
    default:
      return bannerRUB;
  }
};
